"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DateRangePicker = void 0;
var react_1 = __importStar(require("react"));
var date_fns_1 = require("date-fns");
var react_i18next_1 = require("react-i18next");
var DatePicker_1 = require("./DatePicker");
var Timezone_1 = require("./Timezone");
var getMinFromDate = function (toDate, defaultMinValue, allowToNull) {
    if (toDate && defaultMinValue && !allowToNull) {
        var toMinus2Years = (0, date_fns_1.sub)(toDate, { years: 2 });
        return (0, date_fns_1.isBefore)(toMinus2Years, defaultMinValue) ? defaultMinValue : toMinus2Years;
    }
    return defaultMinValue;
};
var getMaxToDate = function (fromDate, defaultMaxValue) {
    if (fromDate && defaultMaxValue) {
        var fromPlus2Years = (0, date_fns_1.add)(fromDate, { years: 2 });
        return (0, date_fns_1.isAfter)(fromPlus2Years, defaultMaxValue) ? defaultMaxValue : fromPlus2Years;
    }
    return defaultMaxValue;
};
function adjustFromDate(date, toDate, allowFromNull, fromDate) {
    if (!date) {
        if (allowFromNull) {
            return null;
        }
        return undefined;
    }
    var newDate = date;
    if (!fromDate && newDate.getHours() === 0 && newDate.getMinutes() === 0) {
        newDate = (0, date_fns_1.set)(newDate, { hours: 0, minutes: 1 });
    }
    if (toDate && (0, date_fns_1.isAfter)(newDate, toDate)) {
        newDate = (0, date_fns_1.set)(newDate, { hours: toDate.getHours(), minutes: toDate.getMinutes() });
    }
    return newDate;
}
function adjustToDate(date, fromDate, allowToNull, toDate) {
    if (!date) {
        if (allowToNull) {
            return null;
        }
        return undefined;
    }
    var newDate = date;
    if (!toDate && newDate.getHours() === 0 && newDate.getMinutes() === 0) {
        newDate = (0, date_fns_1.set)(newDate, { hours: 23, minutes: 59 });
    }
    if (fromDate && (0, date_fns_1.isBefore)(newDate, fromDate)) {
        newDate = (0, date_fns_1.set)(newDate, { hours: fromDate.getHours(), minutes: fromDate.getMinutes() });
    }
    return newDate;
}
function DateRangePicker(props) {
    var _a, _b;
    var defaultMinValue = props.defaultMinValue, defaultMaxValue = props.defaultMaxValue, dateFormat = props.dateFormat, _c = props.allowToNull, allowToNull = _c === void 0 ? false : _c, _d = props.allowFromNull, allowFromNull = _d === void 0 ? false : _d, fromDate = props.fromDate, toDate = props.toDate, setFromDate = props.setFromDate, setToDate = props.setToDate;
    var t = (0, react_i18next_1.useTranslation)().t;
    var handleFromDateChange = function (date) {
        var newDate = adjustFromDate(date, toDate, allowFromNull, fromDate);
        if (newDate !== undefined) {
            var processedDate = newDate ? (0, date_fns_1.set)(newDate, { seconds: 0, milliseconds: 0 }) : null;
            var currentNormalized = fromDate ? (0, date_fns_1.set)(fromDate, { seconds: 0, milliseconds: 0 }) : null;
            if (!currentNormalized || (processedDate === null || processedDate === void 0 ? void 0 : processedDate.getTime()) !== currentNormalized.getTime()) {
                setFromDate(processedDate);
            }
        }
    };
    var handleToDateChange = function (date) {
        var newDate = adjustToDate(date, fromDate, allowToNull, toDate);
        if (newDate !== undefined) {
            var processedDate = newDate ? (0, date_fns_1.set)(newDate, { seconds: 59, milliseconds: 0 }) : null;
            var currentNormalized = toDate ? (0, date_fns_1.set)(toDate, { seconds: 59, milliseconds: 0 }) : null;
            if (!currentNormalized || (processedDate === null || processedDate === void 0 ? void 0 : processedDate.getTime()) !== currentNormalized.getTime()) {
                setToDate(processedDate);
            }
        }
    };
    var minFromDate = (0, react_1.useMemo)(function () { return getMinFromDate(toDate, defaultMinValue, allowToNull); }, [toDate, defaultMinValue, allowToNull]);
    var maxToDate = (0, react_1.useMemo)(function () { return getMaxToDate(fromDate, defaultMaxValue); }, [fromDate, defaultMaxValue]);
    return (react_1.default.createElement("div", { className: "date-range-picker" },
        react_1.default.createElement(DatePicker_1.DatePicker, { name: "from", value: fromDate || undefined, dateFormat: dateFormat, minValue: minFromDate, maxValue: toDate || defaultMaxValue, onChange: handleFromDateChange, allowNull: allowFromNull, placeholder: (_a = t('itemLog:SELECT_START_DAY_PLACEHOLDER')) !== null && _a !== void 0 ? _a : '', className: "date-picker-from", containerClassName: "date-picker-container-from", dataCy: "date-picker-from" }),
        react_1.default.createElement("div", { className: "date-picker-line" }, "to"),
        react_1.default.createElement(DatePicker_1.DatePicker, { name: "to", value: toDate || undefined, dateFormat: dateFormat, minValue: fromDate || defaultMinValue, maxValue: maxToDate, onChange: handleToDateChange, allowNull: allowToNull, placeholder: (_b = t('itemLog:SELECT_END_DAY_PLACEHOLDER')) !== null && _b !== void 0 ? _b : '', className: "date-picker-to", containerClassName: "date-picker-container-to", dataCy: "date-picker-to" }),
        react_1.default.createElement("div", { className: "date-picker-line timezone" },
            react_1.default.createElement(Timezone_1.Timezone, null))));
}
exports.DateRangePicker = DateRangePicker;
